/* eslint-disable */

// startup settings
function startup (klevu) {
  const options = {
    url: {
      search: `${klevu.settings.url.protocol}//eucs21.ksearchnet.com/cs/v2/search`,
      landing: '/pages/search-results',
      protocolFull: `${klevu.settings.url.protocol}//`
    },
    localSettings: true,
    search: {
      searchBoxSelector: 'input.hd-Search_Input',
      searchBoxTarget: false,
      minChars: 1,
      placeholder: 'Search',
      showQuickOnEnter: false,
      fullPageLayoutEnabled: false,
      personalisation: false,
      redirects: [],
      apiKey: 'klevu-159248117270012430'
    },
    analytics: {
      apiKey: 'klevu-159248117270012430'
    }
  }

  klevu(options)
}
// once klevu is interactive, setup the settings
klevu.interactive(() => {
  startup(klevu)
})
// check if klevu is interactive and also if all necessary search instances are powered up
klevu.coreEvent.build({
  name: 'bindLocalBoxes',
  fire () {
    if (
      !klevu.isInteractive ||
      klevu.isUndefined(klevu.search) ||
      klevu.isUndefined(klevu.search.build) ||
      klevu.isUndefined(klevu.searchEvents) ||
      klevu.isUndefined(klevu.searchEvents.functions) ||
      klevu.isUndefined(klevu.searchEvents.functions.bindAllSearchBoxes)
    ) {
      return false
    }
    return true
  },
  maxCount: 500,
  delay: 0
})
// attach to all search boxes on the page
klevu.coreEvent.attach('bindLocalBoxes', {
  name: 'search-boxes-local-boxes',
  fire () {
    klevu.searchEvents.functions.bindAllSearchBoxes.fire()
  }
})

/* eslint-enable */
